// Contraste WCAG 2.x. El acento de cada cuenta es libre (#rrggbb validado en la base), así que el texto
// que va sobre él o junto a él se elige al renderizar para cumplir AA (4,5:1). Nada de esto se guarda.

const HEX = /^#[0-9a-f]{6}$/i;

// Negro puro: con cualquier gris intermedio (p. ej. #141414) hay acentos donde ni la tinta ni el blanco llegan
// a 4,5:1. Con #000/#FFF el peor caso es 4,58:1.
export const INK_DARK = '#000000';
export const INK_LIGHT = '#FFFFFF';
export const AA_TEXT = 4.5;

export function isHexColor(value: unknown): value is string {
  return typeof value === 'string' && HEX.test(value);
}

export function hexToRgb(hex: string): [number, number, number] {
  if (!isHexColor(hex)) throw new Error(`color inválido: ${String(hex)}`);
  const n = Number.parseInt(hex.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

export function rgba(hex: string, alpha: number): string {
  const [r, g, b] = hexToRgb(hex);
  return `rgba(${r},${g},${b},${alpha})`;
}

export function relativeLuminance(hex: string): number {
  const [r, g, b] = hexToRgb(hex).map((v) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  }) as [number, number, number];
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export function contrastRatio(a: string, b: string): number {
  const x = relativeLuminance(a);
  const y = relativeLuminance(b);
  return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05);
}

/** Tinta (negra o blanca) con más contraste sobre `background`. Para cualquier color da al menos 4,58:1. */
export function inkOn(background: string): string {
  return contrastRatio(INK_DARK, background) >= contrastRatio(INK_LIGHT, background) ? INK_DARK : INK_LIGHT;
}

/** El acento como color de texto sobre `background`, o `fallback` si no llega a AA. */
export function readableAccent(accent: string, background: string, fallback: string): string {
  return contrastRatio(accent, background) >= AA_TEXT ? accent : fallback;
}
